import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Util from "../../Classes/Utils";
import {
  GetCountriesWithCities,
  GetOrderAddressBookByAddressType,
} from "../Data";
import { Global } from "../Variables/Global";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import PhoneInput from "react-phone-number-input";
import { toast } from "react-toastify";
import Cookies from "js-cookie";

const CheckoutAR = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [key, setKey] = useState("Home");
  const [city, setCity] = useState("");
  const [cityId, setCityId] = useState("");
  const [cartItems, setCartItems] = useState(location.state.cartItems);
  const [cartCount, setCartCount] = useState(location.state.cartCount);
  const [total, setTotal] = useState(0);
  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [Email, setEmail] = useState("");
  const [Address1, setAddress1] = useState("");
  const [Address2, setAddress2] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState(null);
  const [filteredCities, setFilteredCities] = useState([]);
  const [countryCode, setCountryCode] = useState("");
  const token = Cookies.get("CustomerToken");

  const getCountries = () => {
    GetCountriesWithCities(token).then((res) => {
      setCountries(res);
      getAddressBookDetailsHome(res);
    });
  };


  const getAddressBookDetailsHome = (res) => {
    const getItem = Cookies.get("Number") !== undefined;

    if (getItem) {
      var CustomerId = Cookies.get("Number");
      setAddress1("");
      setAddress2("");
      setEmail("");
      setLastName("");
      setFirstName("");
      setPhoneNumber("");
      setCity("");
      setCountry("");
      GetOrderAddressBookByAddressType(key, CustomerId, token)
        .then((Result) => {
          setAddress1(Result.Address1);
          setAddress2(Result.Address2);
          setFirstName(Result.FirstName);
          setLastName(Result.LastName);
          setPhoneNumber(Result.PhoneNumber);
          setEmail(Result.Email);
          setCountry(Result.State);
          const filteredCountries = res.filter((i) => i.CountryName === Result.State);
          setFilteredCities(filteredCountries[0].Cities);
          setCity(Result?.CityName);
          if (Result?.CityId) {
            fetch(
              Global.API_URL + "Country/GetCitiyNameById/" + Result.CityId,
              {
                method: "GET",
                headers: {
                  Accept: "application/json",
                  "Authorization": `Bearer ${token}`,
                  "Content-Type": "application/json",
                  "Access-Control-Allow-Origin": Global.API_URL,
                },
              }
            )
              .then((response) => {
                return response.json();
              })
              .then((Result) => {
                setCity(Result[0].CityName);
                const value = Result[0].CityId;
                setCityId(value);
                if (Result[0].CountryCode === "UAE") {
                  setCountry("United Arab Emirates");
                  const filteredCountries = res?.filter(
                    (i) => i.CountryName === "United Arab Emirates"
                  );
                  setFilteredCities(filteredCountries[0]?.Cities);
                } else if (Result[0].CountryCode === "LB") {
                  setCountry("Lebanon");
                  const filteredCountries = res?.filter(
                    (i) => i.CountryName === "Lebanon"
                  );
                  setFilteredCities(filteredCountries[0]?.Cities);
                }
              });
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };

  const getTotal = () => {
    var Sumtotal = 0;
    const arr = Array.from(cartItems);
    arr.forEach((element) => {
      if (element.SalePrice === 0) {
        Sumtotal += element.RegularPrice * element.Quantity;
      } else {
        Sumtotal += element.SalePrice * element.Quantity;
      }
    });
    return Sumtotal;
  };
  const handleCheckout = (e) => {
    e.preventDefault();

    const countryCode =
      country === "United Arab Emirates" ? "UAE" :
        country === "Lebanon" ? "LB" :
          null;

    var groupId;
    if (Cookies.get("WishList") !== undefined) {
      groupId = 4;
    } else {
      groupId = 3;
    }
    const offset = new Date().getTimezoneOffset();
    var CartId = Cookies.get("Cart");
    fetch(
      Global.API_URL +
        "Order/CreateOrderAR?" +
        new URLSearchParams({
          CartId: CartId,
          Currency: "AED",
          CustomerUsername: `${FirstName + " " + LastName}`,
          Email: Email,
          PhoneNumber: PhoneNumber,
          Address1: Address1,
          Address2: Address1,
          CityName: city,
          IsDefault: false,
          IsSamePerson: false,
          Offset: offset,
          GroupId: groupId,
          CountryName: country,
          CountryCode: countryCode,
          CountryId: 125,
          PostalCode: "00000",
          State: "Dubai",
          AddressType: key,
          Notes: "Note",
        }),
      {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      }
    ).then((response) => {
      if (response.ok) {
        toast.success("Order Successfuly Compeleted");
        navigate("/AR");
        return response.json();
      }
    });
  };

 

  const FilterCountries = (e) => {
    const value = e.target.value;
    setCountry(value);
    const filteredCountries = countries.filter((i) => i.CountryName === value);
    // const filteredCountries = countries.filter((x) => {
    // 	return x.Cities.some((Cities) => Cities.CityName === value)
    // });
    setFilteredCities(filteredCountries[0].Cities);
  };

  useEffect(() => {
    if(Cookies.get("CustomerToken") === undefined){
      navigate("/AR/Authentication");
    }

    // getDetailsAddressBook();
    getTotal(cartItems);
    getCountries();
  }, [key]);
  return (
    <>
      <div className="breadcrumb-area mb-50 ">
        <div className="container ">
          <div className="row ">
            <div className="col ">
              <div className="breadcrumb-container  d-flex flex-row-reverse   ">
                <div className="breadcrumbArabic HomeShop">
                  <ul>
                    <li className="active">الدفع</li>
                    <li>
                      <a style={{ direction: "rtl" }} href="index.html">
                        <i className="fa fa-home"></i>
                        المنزل
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-section section mb-5 mt-2">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="row">
                <div className="col-12 mb-5">
                  <h4 className="checkout-title directionRtl">مجموع السلة</h4>

                  <div className="checkout-cart-total">
                    <h4 className="ItemReverse">
                      المنتج <span>المجموع</span>
                    </h4>

                    <ul>
                      {cartItems.map((cart, index) => {
                        return (
                          <div key={index}>
                            <li className="ItemReverse">
                              {cart.ProductNameAR} X {cart.Quantity}
                              <span>
                                AED &nbsp;
                                {cart.SalePrice === 0
                                  ? cart.RegularPrice * cart.Quantity
                                  : cart.SalePrice * cart.Quantity}
                              </span>
                            </li>
                          </div>
                        );
                      })}
                    </ul>
                    <p className="ItemReverse">
                      المجموع <span>AED{getTotal(cartItems)}</span>
                    </p>
                    <p className="ItemReverse">
                      الدليفري<span>30</span>
                    </p>

                    <h4 className="ItemReverse">
                      المجموع الكلي<span>AED {getTotal() + 30}</span>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-7 col-md-12 col-12">
              <form className="checkout-form" onSubmit={handleCheckout}>
                <Tabs
                  activeKey={key}
                  id
                  className="mb-3"
                  onSelect={(k) => setKey(k)}
                >
                  <Tab eventKey="Home" title="المنزل">
                    <div className="row row-4 d-flex flex-row-reverse">
                      <div className="col-lg-12 mb-2 ">
                        <div id="billing-form" className="mb-4 directionRtl">
                          <h4 className="checkout-title">Billing Address</h4>

                          <div className="row ">
                            <div className="col-md-6 col-12 mb-2">
                              <label>الإسم الأول*</label>
                              <input
                                value={FirstName}
                                type="text"
                                placeholder="الإسم الأول"
                                onChange={(e) => setFirstName(e.target.value)}
                                required
                              />
                            </div>

                            <div className="col-md-6 col-12 mb-2">
                              <label>العائلة*</label>
                              <input
                                value={LastName}
                                type="text"
                                placeholder="اسم العائلة"
                                onChange={(e) => setLastName(e.target.value)}
                                required
                              />
                            </div>

                            <div className="col-md-6 col-12 mb-2">
                              <label>البريد الإلكتروني*</label>
                              <input
                                value={Email}
                                type="email"
                                placeholder="البريد الإلكتروني"
                                onChange={(e) => setEmail(e.target.value)}
                                required
                              />
                            </div>

                            <div className="col-md-6 col-12 mb-2">
                              <label>رقم الهاتف*</label>
                              <PhoneInput
                                value={PhoneNumber}
                                placeholder="رقم الهاتف"
                                className="inputBox"
                                onChange={setPhoneNumber}
                                required
                              />
                            </div>

                            <div className="col-12 mb-2">
                              <label>البلد</label>
                              <select
                                name="country"
                                className="checkout-form input"
                                onChange={(e) => FilterCountries(e)}
                                value={country}
                                required
                              >
                                <option value="please select country">
                                  الرجاء تحديد البلد
                                </option>
                                {countries &&
                                  countries.map((i, index) => (
                                    <option key={index} value={i.CountryName}>
                                      {i.CountryName}
                                    </option>
                                  ))}
                              </select>
                            </div>

                            <div className="col-12 mb-2">
                              <label>المدينة</label>

                              <select
                                name="City"
                                className="checkout-form input"
                                onChange={(e) => setCity(e.target.value)}
                                value={city}
                                required
                              >
                                <option value="please select city">
                                  Please select city
                                </option>
                                {filteredCities &&
                                  filteredCities.map((i, index) => (
                                    <option key={index} value={i.CityName}>
                                      {i.CityName}
                                    </option>
                                  ))}
                              </select>
                            </div>

                            <div className="col-12 mb-2">
                              <label>العنوان*</label>
                              <input
                                value={Address1}
                                type="text"
                                placeholder="العنوان"
                                onChange={(e) => setAddress1(e.target.value)}
                                required
                              />
                              <input
                                value={Address2}
                                type="text"
                                placeholder="العنوان"
                                onChange={(e) => setAddress2(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>
                  <Tab eventKey="Work" title="العمل">
                    <div className="row row-4 d-flex flex-row-reverse">
                      <div className="col-lg-12 mb-2 ">
                        <div id="billing-form" className="mb-4 directionRtl">
                          <h4 className="checkout-title">Billing Address</h4>

                          <div className="row ">
                            <div className="col-md-6 col-12 mb-2">
                              <label>الإسم الأول*</label>
                              <input
                                value={FirstName}
                                type="text"
                                placeholder="الإسم الأول"
                                onChange={(e) => setFirstName(e.target.value)}
                                required
                              />
                            </div>

                            <div className="col-md-6 col-12 mb-2">
                              <label>العائلة*</label>
                              <input
                                value={LastName}
                                type="text"
                                placeholder="اسم العائلة"
                                onChange={(e) => setLastName(e.target.value)}
                                required
                              />
                            </div>

                            <div className="col-md-6 col-12 mb-2">
                              <label>البريد الإلكتروني*</label>
                              <input
                                value={Email}
                                type="email"
                                placeholder="البريد الإلكتروني"
                                onChange={(e) => setEmail(e.target.value)}
                                required
                              />
                            </div>

                            <div className="col-md-6 col-12 mb-2">
                              <label>رقم الهاتف*</label>
                              <PhoneInput
                                value={PhoneNumber}
                                placeholder="رقم الهاتف"
                                className="inputBox"
                                onChange={setPhoneNumber}
                                required
                              />
                            </div>

                            <div className="col-12 mb-2">
                              <label>البلد</label>
                              <select
                                name="country"
                                className="checkout-form input"
                                onChange={(e) => FilterCountries(e)}
                                value={country}
                                required
                              >
                                <option value="please select country">
                                  الرجاء تحديد البلد
                                </option>
                                {countries &&
                                  countries.map((i, index) => (
                                    <option key={index} value={i.CountryName}>
                                      {i.CountryName}
                                    </option>
                                  ))}
                              </select>
                            </div>

                            <div className="col-12 mb-2">
                              <label>المدينة</label>

                              <select
                                name="City"
                                className="checkout-form input"
                                onChange={(e) => setCity(e.target.value)}
                                value={city}
                                required
                              >
                                <option value="please select city">
                                الرجاء تحديد المدينة
                                </option>
                                {filteredCities &&
                                  filteredCities.map((i, index) => (
                                    <option key={index} value={i.CityName}>
                                      {i.CityName}
                                    </option>
                                  ))}
                              </select>
                            </div>

                            <div className="col-12 mb-2">
                              <label>العنوان*</label>
                              <input
                                value={Address1}
                                type="text"
                                placeholder="العنوان"
                                onChange={(e) => setAddress1(e.target.value)}
                                required
                              />
                              <input
                                value={Address2}
                                type="text"
                                placeholder="العنوان"
                                onChange={(e) => setAddress2(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
                <div className="row">
                  <div className="col-12">
                    <button
                      type="submit"
                      // onClick={() => ()}
                      className="register-button mt-0"
                    >
                      الدفع
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckoutAR;
